var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Repay",
        visible: _vm.isOpen,
        width: "10.2rem",
        "append-to-body": "",
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
      },
    },
    [
      _c("div", [
        _c("div", [
          _c("div", { staticClass: "detail-item spaceLeft" }, [
            _c("span", { staticClass: "detail-item-label" }, [
              _vm._v("Outstanding :"),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "big-num" },
              [
                _c("big-number", {
                  attrs: { number: _vm.pageData.loanAmount },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "unit" }, [_vm._v("TCash")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "detail-item spaceLeft" }, [
            _c("span", { staticClass: "detail-item-label" }, [
              _vm._v("Collateral:"),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "big-num2" },
              [
                _c("big-number", {
                  attrs: { number: _vm.pageData.unitAmount },
                }),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "unit",
                staticStyle: { "margin-bottom": "-0.05rem" },
              },
              [_vm._v("UNIT")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "detail-item spaceLeft" }, [
            _c("span", { staticClass: "detail-item-label" }, [
              _vm._v("Repayment Amount :"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "balance-box" },
              [
                _c(
                  "el-input",
                  {
                    attrs: { max: _vm.maxRepaymentAmount },
                    on: { blur: _vm.blurInput, input: _vm.handleInput },
                    model: {
                      value: _vm.inputVal,
                      callback: function ($$v) {
                        _vm.inputVal = $$v
                      },
                      expression: "inputVal",
                    },
                  },
                  [
                    _c(
                      "template",
                      { slot: "append" },
                      [
                        _vm._v("TCash\n              Balance :"),
                        _c("big-number", { attrs: { number: _vm.balance } }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                display: "flex",
                "justify-content": "center",
              },
            },
            [
              _c("loading-btn", {
                attrs: {
                  type: "primary",
                  label: "Repay now",
                  disabled: _vm.isDisabled,
                },
                on: { clickHandle: _vm.debounceSubmit },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }